import styled from 'styled-components'
// components
import { Collapse as CollapseOrigin } from 'components/UI'
// themes
import { colors } from 'themes/index'
// views
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// utils
import { isColorLight } from 'utils/tree'

export const Wrapper = styled.div<{ $color: string }>`
  border: 2px solid ${({ $color }) => $color};
  border-radius: 6px;
  position: relative;

  ${ButtonsWrapper} {
    right: 4px;
  }
`

export const SectionName = styled.div<{ $color: string }>`
  font-size: 20px;
  color: ${({ $color }) => (isColorLight($color) ? colors.black : colors.white)};
`

export const Collapse = styled(CollapseOrigin)<{ $color: string }>`
  background: ${({ $color }) => $color};
  padding: 8px;
  margin: 0;

  svg {
    fill: ${({ $color }) => (isColorLight($color) ? colors.black : colors.white)};
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 12px 12px 16px;
  position: relative;
`

export const IncidentIdInput = styled.div`
  max-width: 50%;
`

export const ClaimNumberRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  ${IncidentIdInput} {
    width: 50%;
  }
`

export const LinksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const LinkItem = styled.a`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${colors.blue500};
  font-size: 16px;
  width: fit-content;
  text-decoration: none;

  svg {
    font-size: 18px;
  }

  &:hover {
    text-decoration: underline;
  }
`

export const LinksPlaceholder = styled.span`
  font-size: 12px;
  opacity: 0.6;
`
